<template>
  <h1 class="display-1 ma-3 grey--text text--darken-2">
    {{title}}
  </h1>
</template>

<script>
  export default {
    props: {
      title: String
    }
  }
</script>